import AuthenticateAPI from '@/app/apis/main/authenticate/authenticate-api.js';

export default {
    /**
     * @param {*} pinDetails
     */
    async validatePinCode(pinDetails) {
        return AuthenticateAPI.validatePinCode(pinDetails);
    }
}